import { OptionKey } from '@common-fe/common-fe';

import { ReactivationPlanSelected } from '@/modules/employer/components/EmployerReactivation/types';
import { storeCreator } from '@/utils/store/store.utils';

interface State {
  hasBankAccounts: boolean;
  payrollValue: OptionKey;
  fundingValue: OptionKey;
  reCardEmployees: boolean;
  reactivatePlans: boolean;
  selectedPlans: ReactivationPlanSelected[];
  
  setHasBankAccounts: (value: boolean) => void;
  setPayrollValue: (value: OptionKey) => void;
  setFundingValue: (value: OptionKey) => void;
  setReCardEmployees: (value: boolean) => void;
  setReactivatePlans: (value: boolean) => void;
  setSelectedPlans: (plans: ReactivationPlanSelected[]) => void;
  handleReset: () => void;
}

export const useEmployerReactivationStore = storeCreator<State>((set) => ({
  hasBankAccounts: false,
  payrollValue: undefined as OptionKey,
  fundingValue: undefined as OptionKey,
  reCardEmployees: false,
  reactivatePlans: false,
  selectedPlans: [],
  
  setHasBankAccounts: (value) => set((state) => ({ ...state, hasBankAccounts: value })),
  setPayrollValue: (value) => set((state) => ({ ...state, payrollValue: value })),
  setFundingValue: (value) => set((state) => ({ ...state, fundingValue: value })),
  setReCardEmployees: (value) => set((state) => ({ ...state, reCardEmployees: value })),
  setReactivatePlans: (value) => set((state) => ({ ...state, reactivatePlans: value })),
  setSelectedPlans: (plans) => set((state) => ({ ...state, selectedPlans: plans })),
  handleReset: () => set((state) => ({
    ...state,
    hasBankAccounts: false,
    payrollValue: undefined as OptionKey,
    fundingValue: undefined as OptionKey,
    reCardEmployees: false,
    reactivatePlans: false,
    selectedPlans: [],
  })),
}));
